<template>
  <div>
    <v-row dense class="mb-2">
      <v-col cols="12">
        <BTextField
          v-model="form.filename"
          validate="required"
          :disabled="disabled"
          label="Название"
          name="filename"
        />
      </v-col>

      <v-col cols="12" md="4">
        <BTextField
          v-model="form.position"
          :disabled="disabled || form.unzip"
          validate="min_value:1|max_value:100000"
          :min="1"
          :max="100000"
          step="1"
          data-vv-as="Позиция"
          label="Позиция (необязательно)"
          name="position"
          type="number"
          placeholder="Введите позицию"
        />
      </v-col>

      <!--
      <v-col cols="12" md="4">
        <BAutocompleteCommon
          v-model="form.tags"
          :disabled="disabled"
          $type="file-tag"
          placeholder="Начните вводить..."
          multiple
          name="tags"
        />
      </v-col>
      -->
    </v-row>

    <v-row dense>
      <v-col cols="6">
        <BTextFieldDate
          v-model="form.start_at"
          validate="required"
          :min="storage.start_at"
          :max="storage.end_at || form.end_at"
          :disabled="disabled"
          label="Дата начала размещения"
          data-vv-as="Дата начала"
          placeholder="Введите дату"
          name="start_at"
          datetime
        />
      </v-col>

      <v-col cols="6">
        <BTextFieldDate
          v-model="form.end_at"
          :min="storage.start_at || form.start_at"
          :max="storage.end_at"
          :disabled="disabled"
          label="Дата окончания размещения"
          data-vv-as="Дата окончания"
          placeholder="Введите дату"
          name="end_at"
          datetime
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <BTextarea
          v-model="form.description"
          :disabled="disabled"
          label="Описание"
          name="description"
          :rows="2"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <BFileUpload
          :value="form.file && (form.file.raw_file || form.file)"
          :visible-file-name="form.file && form.file.name"
          validate="required"
          :disabled="disabled"
          label="Файл"
          clearable
          show-size
          small-chips
          @change="form.file = $event"
        />
      </v-col>
    </v-row>

    <v-row dense align="center">
      <v-col cols="auto" class="d-flex">
        <v-checkbox
          v-model="form.unzip"
          :disabled="disabled"
          label="Распаковать архив"
          dense
          hide-details
          class="ma-0 pa-0 mr-2"
          name="zip"
        />

        <BInfo
          :disabled="disabled"
          text="Поддерживается только zip архивы"
        />
      </v-col>

      <v-col v-if="!isHiddenATE" cols="auto">
        <v-checkbox
          v-model="form.parse"
          :disabled="disabled"
          label="Автоматически назначить пользователя по имени файла"
          dense
          hide-details
          class="ma-0 pa-0"
          name="parse"
        />
      </v-col>

      <v-col v-if="!isHiddenATE" cols="12">
        <v-icon v-text="'mdi-message-alert-outline'" />
        Для адресного размещения файлов включите обе опции
      </v-col>
    </v-row>

    <template v-if="hasUsers">
      <v-divider class="mt-4" />

      <v-row dense class="my-2">
        <v-col>
          <BTableWithAutocomplete
            v-model="form.users"
            :actions="actions"
            :headers="headers"
            :readonly="disabled"
            type-table="users"
            type-autocomplete="users"
            name="users"
            return-object
          >
            <template #header>
              <h3 class="mb-2">
                Пользователи
              </h3>
            </template>
          </BTableWithAutocomplete>
        </v-col>
      </v-row>

      <v-divider class="mt-2" />
    </template>
  </div>
</template>

<script>
import { FILE_TAG_PUBLICATION } from '@/helpers/enums/params'

import BFileUpload from '@/components/forms/BFileUpload.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'
import BTextFieldDate from '@/components/forms/BTextFieldDate.vue'
import BInfo from '@/components/common/BInfo.vue'
import BTableWithAutocomplete from '@/components/common/BTable/BTableWithAutocomplete.vue'
import { DELETE } from '@/helpers/enums/table-actions'
import { USERS_ROUTES as ROUTES } from '@/views/Users/utils'
import { UserModel as Model } from '@/views/Users/Model'
import { StorageTypes } from '@/typings/api/Publication'

export const TABLE_ACTIONS = Object.freeze([
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Логин',
    value: 'username',
    sortable: false,
    width: 130,
    getRoute: (data) => ({
      name: ROUTES.VIEW,
      params: { id: Model.getId(data) },
    }),
  },
  {
    text: 'Имя',
    value: 'full_name',
    sortable: false,
  },
])

export const createDefaultData = (start_at, end_at, storage_type) => ({
  // id
  file: null,
  filename: '',
  // позиция в хранилище
  position: null,
  tags: [
    FILE_TAG_PUBLICATION,
  ],
  unzip: storage_type === StorageTypes.individual,
  parse: storage_type === StorageTypes.individual,

  start_at,
  end_at,

  description: '',
  users: [],
  // created_at
  // updated_at
})

export default {
  name: 'PublicationStorageFilesForm',
  inject: ['$validator'],
  components: {
    BFileUpload,
    BTextField,
    BTextarea,
    BTextFieldDate,
    BInfo,
    BTableWithAutocomplete,
  },
  props: {
    disabled: Boolean,
    hasUsers: {
      type: Boolean,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    storage: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'start_at' in prop
        && 'end_at' in prop
        && 'storage_type' in prop
      ),
    },
  },
  data: () => ({
    actions: TABLE_ACTIONS,
    headers: TABLE_HEADERS,
  }),
  computed: {
    isZip() {
      const name = this.form.file?.name || ''
      return /\.zip$/.test(name)
    },
    isHiddenATE() {
      return this.storage.storage_type === StorageTypes.general
    },
  },
  watch: {
    'form.unzip': {
      immediate: true,
      handler(value) {
        this.$emit('update:unzip', value)
        // if unzip enabled, clear position so it's not accidentally sent
        if (value) {
          this.$nextTick(() => { this.form.position = null })
        }
      },
    },
  },
}
</script>
